import * as React from 'react';
import { useMemo, useState } from 'react';

type ActiveEditorContextType = {
  activeEditor: string | null;
  setActiveEditor: (key: string | null) => void;
};

const ActiveEditorContext = React.createContext<ActiveEditorContextType | null>(null);

export const ActiveEditorProvider = ({ children }: { children: React.ReactNode }) => {
  const [activeEditor, setActiveEditor] = useState<string | null>(null);

  const contextValue = useMemo(() => ({
    activeEditor,
    setActiveEditor,
  }), [activeEditor]);

  return (
    <ActiveEditorContext.Provider value={contextValue}>
      {children}
    </ActiveEditorContext.Provider>
  );
};

export const useActiveEditor = () => {
  const context = React.useContext(ActiveEditorContext);
  if (!context) {
    throw new Error('useActiveEditor must be used within an ActiveEditorProvider');
  }
  return context;
};

export default ActiveEditorContext;